/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Past_MonthInputs */

const en_past_month = /** @type {(inputs: Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past Month`)
};

const fr_past_month = /** @type {(inputs: Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mois passé`)
};

const de_past_month = /** @type {(inputs: Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzter Monat`)
};

const it_past_month = /** @type {(inputs: Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mese scorso`)
};

const ru_past_month = /** @type {(inputs: Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прошлый месяц`)
};

const es_past_month = /** @type {(inputs: Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El mes pasado`)
};

const zh_cn2_past_month = /** @type {(inputs: Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上个月`)
};

const ja_past_month = /** @type {(inputs: Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先月`)
};

const hi_past_month = /** @type {(inputs: Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बीते हुए महीने में`)
};

const pt_pt2_past_month = /** @type {(inputs: Past_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mês passado`)
};

/**
* | output |
* | --- |
* | "Past Month" |
*
* @param {Past_MonthInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const past_month = /** @type {((inputs?: Past_MonthInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Past_MonthInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_past_month(inputs)
	if (locale === "de") return de_past_month(inputs)
	if (locale === "it") return it_past_month(inputs)
	if (locale === "ru") return ru_past_month(inputs)
	if (locale === "es") return es_past_month(inputs)
	if (locale === "zh-CN") return zh_cn2_past_month(inputs)
	if (locale === "ja") return ja_past_month(inputs)
	if (locale === "hi") return hi_past_month(inputs)
	if (locale === "pt-PT") return pt_pt2_past_month(inputs)
	return en_past_month(inputs)
});